import React from 'react'
import { observer } from 'mobx-react'
import { FrameValue } from 'react-spring'
import { useAnimationProgress } from 'contexts/AnimationProgressContext'
import FirmDashboardViewModel from '../FirmDashboardViewModel'
import WorkspaceSelectorViewHeading from 'components/WorkspaceSelectorViewHeading'

interface FirmDashboardViewHeadingProps {
  vm: FirmDashboardViewModel
  compactionAnimationProgress?: FrameValue<number>
}

export default observer(function FirmDashboardViewHeading({
  vm,
  compactionAnimationProgress,
}: FirmDashboardViewHeadingProps) {
  compactionAnimationProgress = useAnimationProgress(
    compactionAnimationProgress
  )

  return (
    <WorkspaceSelectorViewHeading
      primaryText={'Dashboard'}
      workspaces={vm.filteredWorkspacesWhereUserCanViewDashboard}
      dropdownTitle="Select workspace"
      onChange={vm.selectWorkspaceForFiltering}
      compactionAnimationProgress={compactionAnimationProgress}
      value={vm.workspaceSelectorViewModel.workspace}
      searcher={
        vm.workspaceSelectorViewModel.showWorkspaceSearcher
          ? vm.workspaceSelectorViewModel
          : undefined
      }
      allOptionText={null}
      alwaysUseDropdown={vm.workspaceSelectorUseDropdown}
    />
  )
})
